export default __webpack_public_path__ + "static/media/userIcon-light.80a5e96a.svg";